import { type FC, type ReactNode } from 'react';

import { ApplicationContextObj } from '../context';
import { useApplicationContext } from '../hooks/useApplicationContext';

export interface ApplicationProviderProps {
  readonly children: ReactNode;
}

export const ApplicationProvider: FC<ApplicationProviderProps> = ({ children }) => {
  const context = useApplicationContext();
  return <ApplicationContextObj value={context}>{children}</ApplicationContextObj>;
};
